export interface GridHeaderLegendProps {
  /** Whether any visible day is non-working for this employee, which adds the non-working key. */
  showNonWorkingKey: boolean;
}

/** Colour key for the entry types shown in the grid, rendered beside the Project heading. */
export function GridHeaderLegend({ showNonWorkingKey }: GridHeaderLegendProps) {
  return (
    <div className="flex items-center gap-2 font-normal text-[11px] text-muted-foreground">
      <div className="flex items-center gap-1">
        <div className="w-1 h-3.5 rounded-full" style={{ backgroundColor: 'var(--success-400)' }} aria-hidden="true" />
        <span>Billable</span>
      </div>
      <div className="flex items-center gap-1">
        <div className="w-1 h-3.5 border-l-4 border-double" style={{ borderLeftColor: 'var(--info-400)' }} aria-hidden="true" />
        <span>Scheduled</span>
      </div>
      <div className="flex items-center gap-1">
        <div className="w-1 h-3.5 border-l-4 border-dotted" style={{ borderLeftColor: 'var(--electricviolet-400)' }} aria-hidden="true" />
        <span>Absence</span>
      </div>
      {showNonWorkingKey && (
        <div className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 rounded-sm bg-amber-50 border border-amber-200 dark:bg-amber-900/30 dark:border-amber-700" aria-hidden="true" />
          <span>Non-working</span>
        </div>
      )}
    </div>
  );
}
